'use client'
import { Center, Group, Stack, SegmentedControl } from '@mantine/core'
import { AiraloPackage } from 'lib/airlo-api/getPackages'
import { PlanCard } from './PlanCard'
import styles from './CardsGroup.module.css'
import { useState } from 'react'

type CardsGroupProps = {
  airaloPackages: AiraloPackage[]
  locale: any
  lang: string
}

export function CardsGroup({ airaloPackages, lang, locale }: CardsGroupProps) {
  console.log('CardsGroup airaloPackages:', airaloPackages)
  
  const [onlyInternet, setOnlyInternet] = useState(true)

  const gap = 'var(--mantine-spacing-lg)'

  const airaloPackagesSorted = airaloPackages.sort((a, b) => {
    // Sort by isUnlimited (unlimited last)
    if (a.isUnlimited && !b.isUnlimited) return 1
    if (!a.isUnlimited && b.isUnlimited) return -1

    // Sort by hasVoice (packages with voice last)
    if (a.hasVoice && !b.hasVoice) return 1
    if (!a.hasVoice && b.hasVoice) return -1

    // Then by days (ascending)
    return a.days - b.days
  })

  const packagesWithVoice = airaloPackagesSorted.filter((pkg) => pkg.hasVoice)
  const packagesWithoutVoice = airaloPackagesSorted.filter((pkg) => !pkg.hasVoice)

  const filteredPackages = onlyInternet
    ? packagesWithoutVoice
    : packagesWithVoice

  const onlyInternetLabel = locale?.components?.cardsGroup?.internetLabel
  const internetWithVoiceLabel = locale?.components?.cardsGroup?.internetPlusLabel

  return (
    <Stack gap={'lg'} w='100%'>
      {packagesWithVoice.length > 0 && <Center>
        <SegmentedControl
          size="sm"
          bg="transparent"
          classNames={{
            root: styles.root,
            label: styles.label
          }}
          value={onlyInternet ? onlyInternetLabel : internetWithVoiceLabel}
          onChange={(value) => setOnlyInternet(value === onlyInternetLabel)}
          data={[onlyInternetLabel, internetWithVoiceLabel]}
          color="redi-green.0"
        />
      </Center>}   
      <Group justify="center" gap={gap} w="100%" wrap="wrap" mih={191.89}>
        {filteredPackages.map((airaloPackage) => (
          <PlanCard
            key={airaloPackage.id}

      miw={250}
            w={{
              base: `calc((100% - 1 * ${gap}) / 1)`,
              xs: `calc((100% - 1 * ${gap}) / 2)`,
              sm: `calc((100% - 2 * ${gap}) / 3)`,
              md: `calc((100% - 3 * ${gap}) / 4)`,
              lg: `calc((100% - 3 * ${gap}) / 4)`
            }}
            airaloPackage={airaloPackage}
            lang={lang}
            locale={locale}
          />
        ))}
      </Group>
    </Stack>
  )
}
